module.exports = __webpack_public_path__ + "static/media/interior2.8b382115.webp";